var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lang-select" },
    [
      _c("span", { staticClass: "lang-text" }, [
        _vm._v(_vm._s(_vm.currentLanguageLabel)),
      ]),
      _c(
        "el-dropdown",
        {
          staticClass: "international",
          attrs: { trigger: "click" },
          on: { command: _vm.handleSetLanguage },
        },
        [
          _c(
            "div",
            [
              _c("svg-icon", {
                attrs: {
                  "class-name": "international-icon",
                  "icon-class": "icon-earth",
                },
              }),
              _c("i", { staticClass: "el-icon-arrow-down icon-arrow-down" }),
            ],
            1
          ),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _c(
                "el-dropdown-item",
                { attrs: { disabled: _vm.language === "zh", command: "zh" } },
                [_vm._v(" Chinese ")]
              ),
              _c(
                "el-dropdown-item",
                { attrs: { disabled: _vm.language === "en", command: "en" } },
                [_vm._v(" English ")]
              ),
              _vm.isMX || _vm.isGlobal
                ? _c(
                    "el-dropdown-item",
                    {
                      attrs: { disabled: _vm.language === "es", command: "es" },
                    },
                    [_vm._v(" Español ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }